<template>
    <div class="full-page" :class="{ 'nav-open': $sidebar.showSidebar }">
        <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
            <div class="md-toolbar-row md-offset">
                <div class="md-toolbar-section-start">
                    <h3 class="md-title">{{ $route.name }}</h3>
                </div>
            </div>
        </md-toolbar>
        <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
            <div
                class="page-header header-filter"
                :class="setPageClass"
                filter-color="black"
                :style="setBgImage"
            >
                <div class="container md-offset">
                    <zoom-center-transition
                        :duration="pageTransitionDuration"
                        mode="out-in"
                    >
                        <router-view></router-view>
                    </zoom-center-transition>
                </div>
                <footer class="footer">
                    <div class="container md-offset">
                        <!--            <nav>-->
                        <!--              <ul>-->
                        <!--                <li>-->
                        <!--                  <router-link :to="{ path: '/dashboard' }">Home</router-link>-->
                        <!--                </li>-->
                        <!--                <li>-->
                        <!--                  <a href="#">-->
                        <!--                    Company-->
                        <!--                  </a>-->
                        <!--                </li>-->
                        <!--                <li>-->
                        <!--                  <a href="#">-->
                        <!--                    Portfolio-->
                        <!--                  </a>-->
                        <!--                </li>-->
                        <!--                <li>-->
                        <!--                  <a href="#">-->
                        <!--                    Blog-->
                        <!--                  </a>-->
                        <!--                </li>-->
                        <!--              </ul>-->
                        <!--            </nav>-->
                        <div class="copyright text-center" style="background: linear-gradient(60deg, #ec2229, #ec2235);padding-left: 30px;padding-right: 30px;border-radius: 12px;">
                            &copy; {{ new Date().getFullYear() }}
                            <a href="https://dekmak.co" target="_blank"><img
                                src="https://s3.us-east-2.amazonaws.com/class-products-072018/2018/09/Copyrighted-Dekmak-Logo.png"
                                alt="" style="object-fit: contain; height: 30px; width: auto;"> </a
                            >.
                            Powered by <img
                            src="https://untitled-developers-public.s3.eu-west-3.amazonaws.com/public/CopyRighLogo.png"
                            alt="" style="object-fit: contain; height: 18px; width: auto;">
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>

import {asset} from "@codinglabs/laravel-asset";

export default {
    props: {
        backgroundColor: {
            type: String,
            default: "black"
        }
    },
    inject: {
        autoClose: {
            default: true
        }
    },
    data() {
        return {
            responsive: false,
            showMenu: false,
            menuTransitionDuration: 250,
            pageTransitionDuration: 300,
            year: new Date().getFullYear()
        };
    },
    computed: {
        setBgImage() {
            let images = {
                Pricing: asset("/img/bg-pricing.jpg"),
                Login: asset("/img/login.jpg"),
                Register: asset("/img/register.jpg"),
                Lock: asset("/img/lock.jpg")
            };
            return {
                backgroundImage: `url(${images[this.$route.name]})`
            };
        },
        setPageClass() {
            return `${this.$route.name}-page`.toLowerCase();
        }
    },
    methods: {
        toggleSidebarPage() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },
        linkClick() {
            if (
                this.autoClose &&
                this.$sidebar &&
                this.$sidebar.showSidebar === true
            ) {
                this.$sidebar.displaySidebar(false);
            }
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        toggleNavbar() {
            document.body.classList.toggle("nav-open");
            this.showMenu = !this.showMenu;
        },
        closeMenu() {
            document.body.classList.remove("nav-open");
            this.showMenu = false;
        },
        onResponsiveInverted() {
            if (window.innerWidth < 991) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        }
    },
    mounted() {
        this.onResponsiveInverted();
        window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
        this.closeMenu();
        window.removeEventListener("resize", this.onResponsiveInverted);
    },
    beforeRouteUpdate(to, from, next) {
        // Close the mobile menu first then transition to next page
        if (this.showMenu) {
            this.closeMenu();
            setTimeout(() => {
                next();
            }, this.menuTransitionDuration);
        } else {
            next();
        }
    }
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
    from {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
        opacity: 1;
    }
}

.wrapper-full-page .zoomIn {
    animation-name: zoomIn8;
}

@keyframes zoomOut8 {
    from {
        opacity: 1;
        transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
    }
    to {
        opacity: 0;
        transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
    }
}

.wrapper-full-page .zoomOut {
    animation-name: zoomOut8;
}
</style>
